import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {from, switchMap} from 'rxjs';
import {KeycloakService} from './keycloak.service';

/**
 * Attaches a Keycloak Bearer token to every /api/v1/* request.
 * Token is refreshed automatically if it expires within 30 seconds.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.url.includes('/api/v1/')) {
        return next(req);
    }

    const kc = inject(KeycloakService);

    return from(kc.getValidToken()).pipe(
        switchMap((token) => {
            if (token) {
                req = req.clone({setHeaders: {Authorization: `Bearer ${token}`}});
            }
            return next(req);
        }),
    );
};
